export default __webpack_public_path__ + "static/media/Panel_=_Stage1.3b1d0ac1.svg";